const API_PATH_CREATE = 'restaurant/:id/zones';
const API_PATH_INDEX = 'restaurant/:id/zones/';

export default {
  namespaced: true,
  state: {
    zones: {
      data: [],
      loading: false,
      current_page: 0,
      last_page: 0,
      total: 0
    },
    city: null,
  },
  getters: {
    getZones: (state) => {
      return state.zones.data;
    },
    getCurrentPage: (state) => {
      return state.zones.current_page;
    },
    getLastPage: (state) => {
      return state.zones.last_page;
    },
    getTotalRestaurants: (state) => {
      return state.zones.total
    },
    isLoading: (state) => {
      return state.zones.loading;
    },
    preloaderNextPage : (state) => {
      return state.zones.loading && state.zones.current_page > 0;
    },
    isLastPage : (state) => {
      return state.zones.last_page == state.zones.current_page;
    }
  },
  mutations: {
    resetResults: (state, payload) => {
      return new Promise(resolve => {
        state.zones.data = [];
        state.zones.current_page = 0;
        state.zones.last_page = 0;
        state.zones.total = 0;
        resolve();
      })

    },
  },
  actions: {
    removeZones(store, payload){
      return new Promise((resolve, reject) => {
        if(!payload.id){
          return;
        }

        axios.delete(API_PATH_INDEX.replace(':id', payload.restaurantId)+payload.id)
          .then(({data}) => {
            store.dispatch('loadZones', {
              restaurantId : payload.restaurantId
            })
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    getZone(store, payload){
      return new Promise((resolve, reject) => {
        if(!payload.id){
          return;
        }

        axios.get(API_PATH_INDEX.replace(':id', payload.restaurantId)+payload.id)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    createZone(store, payload){
      return new Promise((resolve, reject) => {
        let url = API_PATH_CREATE.replace(':id', payload.restaurantId);
        let method = 'post';

        if (payload.id) {
          method = 'put';
          url = API_PATH_INDEX.replace(':id', payload.restaurantId) + payload.id
        }

        let data = {
          restaurantId: payload.restaurantId,
          title : payload.title,
          avgSpentTime : payload.avgSpentTime.substr(0,5),
          availableReserveBeforeTime : payload.availableReserveBeforeTime.substr(0, 5),
          isActive : payload.isActive,
          sortOrder : payload.sortOrder
        };

        axios[method](url, data)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    loadZones(store, payload) {
      return new Promise((resolve, reject) => {
        let nextPage = store.getters.getCurrentPage + 1;

        if (store.getters.getLastPage && nextPage > store.getters.getLastPage) {
          return resolve();
        }

        if(store.getters.isLoading){
          return resolve();
        }

        bus.$emit('onProgressLinear');
        store.state.zones.loading = true;

        let data = {};
        data.page = nextPage;
        return axios.get(API_PATH_INDEX.replace(':id', payload.restaurantId), {
          params: data,
        })
          .then(({data}) => {
            store.state.zones.data = (store.getters.getCurrentPage) ? store.getters.getZones().concat(data.data) : data.data
            store.state.zones.loading = false;
            setTimeout(() => {
              bus.$emit('offProgressLinear');
            }, 1000)
            resolve(data);
          })
      });
    },
    resetResults(store,payload){
      return new Promise((resolve,reject) => {
        store.commit('resetResults');
        resolve();
      });
    },
    setSearchQuery(store,search){
      return new Promise(resolve =>{
        store.commit('setSearchQuery',search);
        resolve();
      });
    }
  }
}
